import { useEffect, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Snackbar } from "@mui/material";
import { Table, TableBody, TableCard, TableCell, TableDepartmentTag, TableFilterReturn, TableHead, TableHeaderWrap, TableRow } from "../../../../component/table/table-layout";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import Tooltip from "../../../../component/ui/tooltip";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import { Link } from "react-router";
import StatusChip from "../../../../component/ui/chip/status";
import AvatarProfile from "../../../../component/ui/profile";
import { TitleHeading } from "../../../../component/ui/layout";
import { PlusIcon } from "lucide-react";
import StockSupplyPopup from "../popup";
import { AmountIcon, CategoryIcon, DateIcon, Price2Icon, PriceIcon, YearIcon } from "../../../../component/icons/filter-icons";

const StockSupplyCategoryList = () => {
  const apiCall = useApiCall();
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [tableHeaders, setTableHeaders] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [dropdowns, setDropdowns] = useState({});
  const [selectFilterName, setSelectFilterName] = useState('My Filter')
  const [editingFilters, setEditingFilters] = useState(null);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  useEffect(() => {
    getData({});
    getDropdowns()
  }, []);

  const getData = async ({ filter = filterReturn }) => {
    setIsLoading(true);
    let extraUrl = ``;
    for (let i = 0; i < filter?.length; i++) {
      if (filter[i]?.selectedOpt == "between") {
        extraUrl += `${i === 0 ? "?" : "&"}${filter[i]?.name}=${filter[i]?.value[0]}_${filter[i]?.value[1]}`;
      } else {
        extraUrl += `${i === 0 ? "?" : "&"}${filter[i]?.name}=${filter[i]?.value}`;
      }
    }
    try {
      const res = await apiCall({
        method: "get",
        url: `get-category-wise-summary${extraUrl}`,
      });

      setList(res.data);
      setTableHeaders(res.headers);
      setSaveFilter(res?.custom_filters);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const getDropdowns = async () => {
    try {
      let apiRes = await apiCall({ method: "get", url: "get-supply-dropdown-list" })
      setDropdowns(apiRes?.data);
    } catch (error) {
      console.log("Error", error)
    }
  };

  const filterModalData = [
    {
      name: "total_purchases",
      label: "Total Purchases",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "number",
      Icon: AmountIcon
    },
    {
      name: "total_spent",
      label: "Total Spent",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "number",
      Icon: PriceIcon
    },
    {
      name: "avg_per_purchase",
      label: "Avg Per Purchase",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "number",
      Icon: Price2Icon
    },
    {
      name: "category_name",
      label: "Category",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: dropdowns?.categories,
      dropdownKey: "name",
      dropdownVal: "id",
      Icon: CategoryIcon
    },
    {
      name: "year",
      label: "Year",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "number",
      Icon: YearIcon
    },
    {
      name: "date_range",
      label: "Date Range",
      options: ["between", 'is'],
      selectedOpt: "between",
      value: "",
      betweenType: "date",
      type: "date",
      isOpts: [
        {label: 'This Month', value: 'this_month'},
        {label: 'Last Month', value: 'last_month'},
        {label: 'This Year', value: 'this_year'},
        {label: 'Last Year', value: 'last_year'},
        {label: 'All Time', value: 'all_time'}
      ],
      Icon: DateIcon
    },
  ];

  const [addModal, setAddModal] = useState(false);
  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    getData();
    setAddModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  return (
    <>
      <div className={Style.leaveMainPage}>
        <TableFilterReturn
          filterReturn={filterReturn}
          onChange={(filters) => {
            setFilterReturn(filters);
            getData({ filters });
          }}
        />

        <div className={Style.report_table__header}>
          <span className={Style.report_table__title}>
            <TitleHeading title={`Purchase Usage by Category`} />
          </span>

          <div className={Style.bpfl_action}>
            <div className={Style.bpfl_action}>
              <div
                className={Style.bpfl_action}
                onClick={() => { setAddModal(true) }}
              >
                <Tooltip
                  content={"Add Data"}
                  position={"left center"}
                  className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
                >
                  <div className={Style.icon}>
                    <PlusIcon size={'1em'} />
                  </div>
                </Tooltip>
              </div>
            </div>
            <Tooltip
              className={Style.bpfl_actionItems}
              content={"Table Filter"}
              position={"left center"}
            >
              <div
                className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                  }`}
                onClick={() => {
                  setShowModalFilterTable(true);
                }}
              >
                <div className={Style.icon}>
                  <FilterFunnel01Icon />
                </div>
              </div>
            </Tooltip>
            <div className={`${Style.bpfl_action}`}>
              <Tooltip
                className={`${Style.bpfl_actionItems}`}
                content={"Customize Table"}
                position={"left center"}
              >
                <div
                  className={`${Style.bpfl_actionBtn}`}
                  onClick={() => {
                    setShowModalCustomizeTabs(true);
                  }}
                >
                  <div className={Style.icon}>
                    <LayoutTopIcon />
                  </div>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>

        <div className={Style.LeaveBody}>
          <TableCard>
            {isLoading ? (
              <InnerLoader />
            ) : !lists?.length ? (
              <div className="w-full h-full flex items-center justify-center">
                <DataNotFound title={"Purchase Usage by Category"} />
              </div>
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell header sticky>
                      <div className="flex gap-4 items-center">
                        <span>Category Name</span>
                      </div>
                    </TableCell>
                    {tableHeaders?.map((eachHead, index) =>
                      eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                        <TableCell header key={index}>
                          <TableHeaderWrap>
                            <span>{eachHead?.value}</span>
                          </TableHeaderWrap>
                        </TableCell>
                      ) : null
                    )}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {lists?.map((eachList, index) => {
                    return (
                      <TableRow key={`${index}`}>
                        <TableCell sticky>
                          <div className={`${Style.tableActionArea} !gap-4`}>
                            <div className="flex gap-[10px]">
                              <div className="flex items-center gap-3">
                                <div className="font-semibold text-[15px] leading-5">{eachList?.category_name}</div>
                              </div>
                            </div>
                          </div>
                        </TableCell>

                        {tableHeaders?.map((eachHead, i) =>
                          eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                            <>
                              {eachHead.key === "status" ? (
                                <TableCell
                                  key={`${i}-${index}`}
                                  className={`text-center`}
                                >
                                  {eachList[eachHead?.key] === "Assigned" ? (
                                    <StatusChip color="green">{eachList[eachHead?.key] || "--"}</StatusChip>
                                  ) : eachList[eachHead?.key] === "Retired" ? (
                                    <StatusChip color="red">{eachList[eachHead?.key] || "--"}</StatusChip>
                                  ) : eachList[eachHead?.key] === "Under Repair" ? (
                                    <StatusChip color="purple">{eachList[eachHead?.key] || "--"}</StatusChip>
                                  ) : (
                                    <StatusChip color="blue">{eachList[eachHead?.key] || "--"}</StatusChip>
                                  )}
                                </TableCell>
                              ) : eachHead.key === "assigned_to_department" ? (
                                <TableCell key={`${i}-${index}`}>
                                  <div className="flex flex-wrap gap-2 max-w-[550px]">
                                    {eachList?.assigned_to_department ? (
                                      eachList.assigned_to_department.split(",").map((dep, index) => (
                                        <TableDepartmentTag
                                          title={dep.trim()}
                                        />
                                      ))
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </TableCell>
                              ) : eachHead.key === "assigned_to_designation" ? (
                                <TableCell key={`${i}-${index}`}>
                                  <div className="flex flex-wrap gap-2 max-w-[550px]">
                                    {eachList?.assigned_to_designation ? (
                                      eachList?.assigned_to_designation.split(",").map((des, index) => (
                                        <span>{des.trim()}</span>
                                      ))
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </TableCell>
                              ) : eachHead.key === "created_by" ? (
                                <TableCell key={`${i}-${index}`}>
                                  <AvatarProfile
                                    title={eachList?.created_by}
                                    src={eachList?.created_by_profile_picture?.split(",")[index]?.trim()}
                                  />
                                </TableCell>
                              ) : (
                                <TableCell key={`${i}-${index}`}>
                                  {(eachList[eachHead?.key]) ? (typeof eachList[eachHead?.key] == "string" && eachList[eachHead?.key]?.slice(0, 5) == "https") ? <Link to={eachList[eachHead?.key]} target="_blank" className="text-blue-600 underline">View</Link> : eachList[eachHead?.key] : "-"}
                                </TableCell>
                              )}
                            </>
                          ) : null
                        )}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            )}
          </TableCard>
        </div>
      </div>

      {addModal &&
        <StockSupplyPopup
          onClose={() => { setAddModal(false); }}
          onError={onError}
          onSubmit={onSuccess}
          dropdowns={dropdowns}
        />
      }

      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            setShowModalFilterTable(false);
            setFilterReturn(filters);
            setSelectFilterName(filterName);
            setEditingFilters(editingFilter);
            getData({ filter: filters });
          }}
          selectFilterName={selectFilterName}
          editingFilters={editingFilters}
          saveFilter={saveFilter}
          apiUrl="get-category-wise-summary"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeaders}
          onClose={() => { setShowModalCustomizeTabs(false); }}
          onSave={(saveHeaders) => { setTableHeaders(saveHeaders); }}
          apiUrl="get-category-wise-summary"
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default StockSupplyCategoryList;
